<template>
    <div class="Img-checkbox">
        <div class="img-item" v-for="(file, index) in imageFile" :key="index" @click="clickEvent(index)">
            <div class="preview">
                <img :src="file.blob" alt="">
            </div>
            <div class="check-wrap" :class="{'active': imgSeletedId == index}">
                <span class="check-box">
                    <img v-show="imgSeletedId == index" :src="checkedImg" alt="">
                </span>
                <span class="checkbox-text">設為封面</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ImgCheckbox',
    data () {
        return {
            checkedImg: require('@/assets/img/component/widge/checkbox/tick_white.svg'),
            imgSeletedId: this.selectId
        }
    },
    props: {
        imageFile: '',
        selectId: ''
    },
    methods: {
        clickEvent: function (index) {
            this.imgSeletedId = index
            this.$emit('getSelectId', this.imgSeletedId)
        }
    }
}
</script>
<style   lang="scss">
    .Img-checkbox{
        position: relative;
        display: flex;
        flex-wrap: wrap;
        cursor: pointer;
        .img-item{
            border-radius: 4px;
            margin-right: 20px;
            margin-bottom: 40px;
            .preview{
                display: flex;
                width: 172px;
                height: 129px;
                margin-bottom: 20px;
                align-items: center;
                border-radius: 4px;
                overflow: hidden;
                >img{
                    width: 100%;
                } 
            }
            
            .check-wrap{
                display: flex;
                align-items: center;
                .check-box{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 20px;
                    height: 20px;
                    font-weight: 300;
                    margin-right: 8px;
                    border-radius: 3px;
                    background: #fff;
                    border: 1px solid #d5dad8
                }
                .checkbox-text{
                    color: #a8a5a4
                }
            }       
            .check-wrap.active{
                .check-box{
                    background: #ff9275;
                    border: 1px solid #ff9275
                }
                .checkbox-text{
                    color: #676362;
                }
            }         
            
        }
        .img-item:nth-child(5n){
            margin-right: 0px;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/ImgCheckbox.vue